if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.zoom = 1;
        this.panX = 0;
        this.panY = 0;
        this.isDragging = false;
        this.wasDragging = false;
        this.dragStartX = 0;
        this.dragStartY = 0;

        this.zoomInButton = this.querySelector('.jd-modal-zoom-in');
        this.zoomOutButton = this.querySelector('.jd-modal-zoom-out');
        this.zoomResetButton = this.querySelector('.jd-modal-zoom-reset');

        this.prevButton = this.querySelector('.jd-modal-gallery-arrow--prev');
        this.nextButton = this.querySelector('.jd-modal-gallery-arrow--next');

        this.modalContent = this.querySelector('.product-media-modal__content');

        this.zoomInButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          this.setZoom(this.zoom + 0.25);
        });

        this.zoomOutButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          this.setZoom(this.zoom - 0.25);
        });

        this.zoomResetButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          this.resetZoom();
        });

        this.prevButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          this.changeMedia(-1);
        });

        this.nextButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          this.changeMedia(1);
        });

        this.querySelector('.jd-modal-zoom-controls')?.addEventListener('pointerup', (event) => {
          event.stopPropagation();
          event.stopImmediatePropagation();
        });

        this.querySelector('.jd-modal-gallery-nav')?.addEventListener('pointerup', (event) => {
          event.stopPropagation();
          event.stopImmediatePropagation();
        });

        this.modalContent?.addEventListener(
          'wheel',
          (event) => {
            if (!this.hasAttribute('open')) return;

            const target = this.getZoomTarget();
            if (!target) return;

            event.preventDefault();
            event.stopPropagation();

            if (event.deltaY < 0) {
              this.setZoom(this.zoom + 0.25);
            } else {
              this.setZoom(this.zoom - 0.25);
            }
          },
          { passive: false }
        );

        this.modalContent?.addEventListener('pointerdown', (event) => {
          const target = this.getZoomTarget();

          if (!target) return;
          if (!event.target.closest('[data-media-id]')) return;
          if (this.zoom <= 1) return;

          event.preventDefault();
          event.stopPropagation();

          this.isDragging = true;
          this.wasDragging = false;

          this.dragStartX = event.clientX - this.panX;
          this.dragStartY = event.clientY - this.panY;

          target.setPointerCapture?.(event.pointerId);
          target.style.cursor = 'grabbing';
        });

        this.modalContent?.addEventListener('pointermove', (event) => {
  if (!this.isDragging) return;

  event.preventDefault();
  event.stopPropagation();

  const newPanX = event.clientX - this.dragStartX;
  const newPanY = event.clientY - this.dragStartY;

  // Mark it as a drag once the mouse has actually moved
  if (
    Math.abs(newPanX - this.panX) > 3 ||
    Math.abs(newPanY - this.panY) > 3
  ) {
    this.wasDragging = true;
  }

  this.panX = newPanX;
  this.panY = newPanY;

  this.applyTransform();
});

        this.modalContent?.addEventListener('pointerup', (event) => {
  const image = this.getActiveImage();
  const target = this.getZoomTarget();

  if (event.target === image || event.target.closest('[data-media-id]')) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  if (!this.isDragging) return;

  this.isDragging = false;

  if (target) {
    target.releasePointerCapture?.(event.pointerId);
    target.style.cursor = this.zoom > 1 ? 'grab' : 'zoom-in';
  }
});

        this.modalContent?.addEventListener('pointercancel', () => {
          this.isDragging = false;
        });
this.modalContent?.addEventListener('click', (event) => {
  const target = this.getZoomTarget();
  const image = this.getActiveImage();

  if (!target || !image) return;

  // Only trigger when clicking the actual image
  if (event.target !== image) return;

  // Don't treat the end of a drag as a click
  if (this.wasDragging) {
    this.wasDragging = false;
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  if (this.zoom > 1) {
    this.resetZoom();
  } else {
    this.setZoom(2);
  }
});
        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            event.stopPropagation();
            this.changeMedia(-1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            event.stopPropagation();
            this.changeMedia(1);
          }

          if (event.key === '+' || event.key === '=') {
            event.preventDefault();
            this.setZoom(this.zoom + 0.25);
          }

          if (event.key === '-') {
            event.preventDefault();
            this.setZoom(this.zoom - 0.25);
          }

          if (event.key === '0') {
            event.preventDefault();
            this.resetZoom();
          }
        });
      }

hide() {
  const scrollPosition = this.savedScrollPosition ?? window.scrollY;

  this.resetZoom();
  super.hide();

  requestAnimationFrame(() => {
    window.scrollTo({
      top: scrollPosition,
      left: 0,
      behavior: 'instant'
    });
  });
}

show(opener) {
  this.savedScrollPosition = window.scrollY;

  super.show(opener);
  this.showActiveMedia();
}

      getMediaItems() {
        return Array.from(
          this.querySelectorAll(
            '.product-media-modal__content > [data-media-id]'
          )
        );
      }

      getActiveMedia() {
        return this.querySelector(
          '.product-media-modal__content > [data-media-id].active'
        );
      }

      getActiveImage() {
        const activeMedia = this.getActiveMedia();

        if (!activeMedia) return null;

        if (activeMedia.tagName === 'IMG') {
          return activeMedia;
        }

        return activeMedia.querySelector('img');
      }

      getZoomTarget() {
        const activeMedia = this.getActiveMedia();

        if (!activeMedia) return null;

        /*
         * IMPORTANT:
         * Shopify image media can itself be the IMG element.
         * In that case we must transform activeMedia directly.
         */
        if (activeMedia.tagName === 'IMG') {
          return activeMedia;
        }

        if (activeMedia.matches('.global-media-settings')) {
          return activeMedia;
        }

        return (
          activeMedia.querySelector('img') ||
          activeMedia.querySelector('.global-media-settings') ||
          activeMedia.querySelector('.media')
        );
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const mediaItems = this.getMediaItems();

        mediaItems.forEach((element) => {
          element.classList.remove('active');
        });

        let activeMedia = mediaItems.find(
          (element) => element.dataset.mediaId === mediaId
        );

        if (!activeMedia) {
          activeMedia = mediaItems[0];
        }

        if (!activeMedia) return;

        activeMedia.classList.add('active');

        this.loadActiveMedia(activeMedia);
        this.resetZoom();
      }

      changeMedia(direction) {
        const mediaItems = this.getMediaItems();

        if (mediaItems.length < 2) return;

        const activeMedia = this.getActiveMedia();

        let currentIndex = mediaItems.indexOf(activeMedia);

        if (currentIndex === -1) {
          currentIndex = 0;
        }

        let newIndex = currentIndex + direction;

        if (newIndex < 0) {
          newIndex = mediaItems.length - 1;
        }

        if (newIndex >= mediaItems.length) {
          newIndex = 0;
        }

        const oldTarget = this.getZoomTarget();

        if (oldTarget) {
          oldTarget.style.transform = '';
          oldTarget.style.transformOrigin = '';
          oldTarget.style.cursor = '';
        }

        mediaItems.forEach((element) => {
          element.classList.remove('active');
        });

        const newMedia = mediaItems[newIndex];

        newMedia.classList.add('active');

        window.pauseAllMedia();

        this.loadActiveMedia(newMedia);
        this.resetZoom();
      }

      loadActiveMedia(activeMedia) {
        const activeMediaTemplate = activeMedia.querySelector?.('template');

        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      setZoom(value) {
        const target = this.getZoomTarget();

        if (!target) return;

        this.zoom = Math.min(4, Math.max(1, value));

        if (this.zoom === 1) {
          this.panX = 0;
          this.panY = 0;
        }

        this.applyTransform();
        this.updateZoomDisplay();
      }

      resetZoom() {
        const target = this.getZoomTarget();

        this.zoom = 1;
        this.panX = 0;
        this.panY = 0;
        this.isDragging = false;

        if (target) {
          target.style.transform = '';
          target.style.transformOrigin = '';
          target.style.cursor = 'zoom-in';
        }

        this.updateZoomDisplay();
      }

      applyTransform() {
        const target = this.getZoomTarget();

        if (!target) return;

        target.style.transformOrigin = 'center center';

        target.style.transform =
          `translate(${this.panX}px, ${this.panY}px) scale(${this.zoom})`;

        target.style.cursor =
          this.zoom > 1 ? 'grab' : 'zoom-in';
      }

      updateZoomDisplay() {
        if (this.zoomResetButton) {
          this.zoomResetButton.textContent =
            `${Math.round(this.zoom * 100)}%`;
        }

        if (this.zoomOutButton) {
          this.zoomOutButton.disabled = this.zoom <= 1;
        }

        if (this.zoomInButton) {
          this.zoomInButton.disabled = this.zoom >= 4;
        }
      }
    }
  );
}